var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { SpaceItem } from './SpaceItem';
import { toArray } from '../../Utils/react';
var alignType = {
    Top: 'items-start',
    Middle: 'items-center',
    Bottom: 'items-end',
};
var Space = /** @class */ (function (_super) {
    __extends(Space, _super);
    function Space(props) {
        var _this = _super.call(this, props) || this;
        _this.renderChild = function (child, i, latestIndex) {
            var _a = _this.props, size = _a.size, direction = _a.direction, wrap = _a.wrap, split = _a.split, unit = _a.unit;
            return (React.createElement(SpaceItem, { size: size, key: i, direction: direction, index: i, split: split, wrap: wrap, latestIndex: latestIndex, unit: unit }, child));
        };
        return _this;
    }
    Space.prototype.render = function () {
        var _this = this;
        var _a = this.props, direction = _a.direction, size = _a.size, wrap = _a.wrap, children = _a.children, align = _a.align, rest = __rest(_a, ["direction", "size", "wrap", "children", "align"]);
        var SpaceCls = [
            'inline-flex',
            direction == 'horizontal' ? 'flex-row' : 'flex-col',
            wrap ? 'flex-wrap' : 'flex-no-wrap',
            alignType[align],
        ];
        var childNodes = toArray(children, { keepEmpty: true });
        return childNodes.length == 0 ? null : (React.createElement(DivTag, __assign({ atomics: SpaceCls }, rest, { name: Space.NAME }), childNodes.map(function (child, i) {
            return _this.renderChild(child, i, childNodes.length - 1);
        })));
    };
    Space.defaultProps = defaultProps;
    Space.NAME = 'space';
    Space.displayName = 'Space';
    return Space;
}(PureComponent));
export { Space };
